<template>
<div class="in-report-manage">
    <component :is="views"></component>
</div>
</template>

<script>
import pcList from '@/views/PCGL/components/pcList';
export default {
    data() {
        return {
            views: pcList
        }
    },
    methods: {},
    mounted() {}
}
</script>
